import clsx from "clsx";
import { Checkbox, Col, ModalProps, useModal } from "@commonlibs";
import { createModal } from "@commonlibs";
import Modal from "ui/common/components/feedback/Modal/Modal";
import ModalFooter from "ui/common/components/feedback/Modal/ModalFooter/ModalFooter";
import useTranslate from "ui/locale/hooks/useTranslate";
import PartnerAutocomplete from "ui/partner/container/PartnerAutocomplete/PartnerAutocomplete";
import { useEffect, useState } from "react";
import type { PartnerDto } from "common/models/api/models/PartnerDto";
import { ExportGiftCardsModalForm, ExportGiftCardsStrategy } from "./ExportGiftCardsModal.types";
import useExportPurchasedGiftCards from "features/giftcards/hooks/useExportPurchasedGiftCards";
import { useQueryClient } from "react-query";
import { Queries } from "ui/query/queries";
import { ModalGiftCardsSelect } from "../common/GiftCardsModal.styles";

const ExportGiftCardsModal = createModal<ModalProps>(({ className, ...rest }) => {
    const translate = useTranslate();
    const { hideModal } = useModal();
    const queryClient = useQueryClient();

    const strategies = [
        { label: "Ninguna", value: ExportGiftCardsStrategy.DEFAULT },
        { label: "Ktronix", value: ExportGiftCardsStrategy.KTRONIX },
        { label: "Éxito", value: ExportGiftCardsStrategy.EXITO },
    ];

    const [partner, setPartner] = useState<PartnerDto>();
    const [strategy, setStrategy] = useState<string>(strategies[0].value);
    const [onlyPending, setOnlyPending] = useState(false);

    const { mutate, isLoading } = useExportPurchasedGiftCards({ onSettled: handleOnSettled });

    useEffect(() => {
        queryClient.invalidateQueries(Queries.PARTNER_FIND_ALL_WITHOUT_PARENT);
    }, [queryClient]);

    function closeModal() {
        hideModal(ExportGiftCardsModal.id);
    }

    function handleOnSubmit() {
        const form: ExportGiftCardsModalForm = {
            partner: partner?.address,
            strategy: strategy as ExportGiftCardsStrategy,
            onlyPending,
        };
        mutate({ ...form });
    }

    function handleOnSettled() {
        closeModal();
    }

    return (
        <Modal title={translate("export")} className={clsx("export-gift-cards-modal", className)} style={{ width: "550px" }} {...rest}>
            <Col gap={30}>
                <PartnerAutocomplete
                    label={translate("giftCardPartnerName")}
                    placeholder={translate("giftCardPartnerName")}
                    name="partner"
                    required
                    partnerType="giftcard"
                    value={partner}
                    onChange={(e) => {
                        const partner = e as PartnerDto;
                        setPartner(partner);
                    }}
                />
                <ModalGiftCardsSelect
                    label={translate("giftcardDownloadFormat")}
                    value={strategy as ExportGiftCardsStrategy}
                    onChange={(e) => setStrategy(e)}
                    options={strategies}
                />
                <Checkbox
                    name="onlyPending"
                    label={translate("exportOnlyPendingGiftCards")}
                    value={onlyPending}
                    onChange={() => setOnlyPending((prev) => !prev)}
                />
                <ModalFooter
                    cancelLabel={translate("cancel")}
                    mainLabel={translate("export")}
                    onCancel={closeModal}
                    onSubmit={handleOnSubmit}
                    isLoading={isLoading}
                />
            </Col>
        </Modal>
    );
});

export default ExportGiftCardsModal;
